/* Common Views */
export {default as HomeView} from 'views/common/HomeView';
export {default as ProfileView} from 'views/common/ProfileView';
export {default as PortfolioView} from 'views/common/PortfolioView'
export {default as ResetPasswordView} from 'views/common/ResetPasswordView';
/* Administration Views */
export {default as InnspiralView} from 'views/administration/InnspiralView';
export {default as UtilitiesView} from 'views/administration/UtilitiesView';
/* Setup Views */
export {default as ManagerSetupView} from 'views/setup/ManagerSetupView';
export {default as CommitteeSetupView} from 'views/setup/CommitteeSetupView';
export {default as PortfolioSetupView} from 'views/setup/PortfolioSetupView';
export {default as CompanyView} from 'views/setup/CompanyView';
/* Postulation Views */
export {default as ProjectPostulationView} from 'views/postulation/ProjectPostulationView';
export {default as PostulationListView} from 'views/postulation/PostulationListView';
export {default as PostulationThanksView} from 'views/postulation/PostulationThanksView';
/* Selection Views */
export {default as SelectionView} from 'views/selection/SelectionView';
export {default as WorkshopView} from 'views/selection/WorkshopView';
/* Files Views */
export {default as ProjectView} from 'views/files/FileView';
export {default as ProjectsView} from 'views/files/FilesView';
export {default as SignatureView} from 'views/files/SignatureView';
export {default as EditFileView} from 'views/files/EditFileView';
/* Economic Selection Views*/
export {default as EconomicSelectionView} from 'views/selection_economic/EconomicSelectionView';
/* Dashboard Views */
export {default as DashboardSummaryView} from 'views/dashboard/DashboardSummaryView';
export {default as DashboardProjectsView} from 'views/dashboard/DashboardProjectsView';
export {default as DashboardAreaView} from 'views/dashboard/DashboardAreaView';
/* Consultant Views */
export {default as ConsultantView} from 'views/consultant/ConsultantView';



// WEBPACK FOOTER //
// ./src/imports/ViewsImports.js